module.exports = __webpack_public_path__ + "static/media/glowco_5_instant active turban in black.15599aac.jpeg";